// local
import { TRENDS, SENATE_URL, USHOUSE_URL, USGOV_URL } from './constants.js';
// packages
import { get } from 'svelte/store';
import { createFeed } from './stores.js';
// import { topojsonToGeoJson } from './utils/geography.js';
import {
  renderSvelteComponent,
  findSvelteComponentContainer,
  findSvelteComponentContainers,
} from './utils/render.js';
import { derived } from 'svelte/store';

// components
import BalanceOfPower from './components/BalanceOfPower.svelte';
import OfficeView from './components/OfficeView.svelte';
import PartyScoreboard from './components/PartyScoreboard.svelte';
import MapKey from './components/MapKey.svelte';

/**
 * @type {Map<string, import('../types.jsjs').Crosswalk>}
 */
// const crosswalk = index(window.CROSSWALK, indexByApId);

//components

async function main() {
  const trendsFeed = await createFeed(TRENDS);
  const senateFeed = await createFeed(SENATE_URL);
  const houseFeed = await createFeed(USHOUSE_URL);
  const govFeed = await createFeed(USGOV_URL);

  const COMPONENT_TYPES = {
    'embed-trends': BalanceOfPower,
    'embed-map': OfficeView,
    'embed-table': PartyScoreboard,
    'embed-map-key': MapKey,
  };

  Object.keys(COMPONENT_TYPES).forEach((componentType) => {
    // Select the svelte JS that this type needs to render
    const svelteScript = COMPONENT_TYPES[componentType];

    // Find them all and render them
    const elements = findSvelteComponentContainers(
      `[data-component-type="${componentType}"]`
    );

    if (elements.length) {
      elements.forEach((element) => {
        // get the id
        const elementId = element.id;

        let feed_trends;
        let resultsFeed;
        let officeViewParams;
        let partyScoreboardParams;

        if (elementId.includes('senate')) {
          feed_trends = derived(trendsFeed, ($feed) => $feed.senate);
          resultsFeed = senateFeed;
          officeViewParams = {
            geographyType: 'states',
            feed: resultsFeed,
            additionalFeaturesKey: 'states_extra',
          };
          partyScoreboardParams = {
            feed: senateFeed,
            numColumns: 4,
            getName: (d) => `${d.ap}`,
            election: 'senate',
          };
        } else if (elementId.includes('house')) {
          feed_trends = derived(trendsFeed, ($feed) => $feed.house);
          resultsFeed = houseFeed;
          officeViewParams = {
            geographyType: 'districts',
            feed: resultsFeed,
            divisionType: 'district',
            additionalFeaturesKey: 'districts_extra',
          };
          partyScoreboardParams = {
            feed: resultsFeed,
            getCode: (d) => d.slice(0, 2),
            getName: (d) => `${d.state}-${d.seatNumber}`,
            numColumns: 4,
            election: 'house',
          };
        } else if (elementId.includes('gov')) {
          feed_trends = derived(trendsFeed, ($feed) => $feed.governor);
          resultsFeed = govFeed;
          partyScoreboardParams = {
            feed: govFeed,
            numColumns: 4,
            getName: (d) => `${d.ap}`,
            election: 'governors',
          };
        }

        if (svelteScript == BalanceOfPower) {
          renderSvelteComponent(
            BalanceOfPower,
            /** @type {HTMLElement} */
            element,
            {
              feed: feed_trends,
            }
          );
        } else if (svelteScript == OfficeView) {
          renderSvelteComponent(
            OfficeView,
            /** @type {HTMLElement} */
            element,
            officeViewParams
          );
        } else if (svelteScript == PartyScoreboard) {
          renderSvelteComponent(
            PartyScoreboard,
            /** @type {HTMLElement} */
            element,
            partyScoreboardParams
          );
        } else if (svelteScript == MapKey) {
          renderSvelteComponent(
            MapKey,
            /** @type {HTMLElement} */
            element,
            {
              noLeads: false,
            }
          );
        }
      });
    }
  });

  //////// SECTION DROPDOWN FILTERS
  // dropdown select
  function filterDropdown(e, section) {
    // value of dropdown
    let value = e.detail.value;
    // get the class and id for the elements we want
    let itemClass = '';
    let scoreboardId = '';
    if (section == 'house') {
      itemClass = '.house-race-item';
      scoreboardId = '#house-scoreboard';
    } else if (section == 'senate') {
      itemClass = '.senate-race-item';
      scoreboardId = '#senate-scoreboard';
    } else if (section == 'gov') {
      itemClass = '.governors-race-item';
      scoreboardId = '#gov-scoreboard';
    }

    // find relevant board
    let scoreboardEl = findSvelteComponentContainer(scoreboardId);
    if (!scoreboardEl) return;

    // filter!
    let findItems = scoreboardEl.querySelectorAll(itemClass);
    findItems.forEach((e) => {
      if (value == 'show_all') {
        e.parentElement.classList.remove('hidden');
        e.parentElement.setAttribute('aria-hidden', 'false');
        e.classList.remove('hidden');
        e.classList.remove('filtered');
        e.setAttribute('aria-hidden', 'false');

        e.closest('table').classList.remove('hidden');
      } else if (e.classList.contains(value)) {
        e.classList.remove('hidden');
        e.classList.add('filtered');
        e.setAttribute('aria-hidden', 'false');
      } else {
        e.classList.add('hidden');
        e.classList.remove('filtered');
        e.setAttribute('aria-hidden', 'true');

        e.closest('table').classList.add('hidden');
      }
    });

    let filtered = scoreboardEl.querySelectorAll('.filtered');
    filtered.forEach((e) => {
      e.closest('table').classList.remove('hidden');
    });
  }

  // house races
  let houseDropdown = findSvelteComponentContainer('select.house-race-select');
  if (houseDropdown) {
    houseDropdown.addEventListener('change', (event) => {
      // Create a new custom event with the relevant data,
      // because the shadow DOM prevents some attributes from passing through
      const filterEvent = new CustomEvent('filter-dropdown', {
        detail: {
          value: event.target.value || '',
        },
        bubbles: event.bubbles,
        cancelable: event.cancelable,
      });
      filterDropdown(filterEvent, 'house');
    });
  }
}

main().catch(console.error);
